import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { ReactComponent as IconHead2 } from "../../../assets/icon/icon-head-2.svg"
import { DatePicker } from 'antd'
import moment from "moment"
import StaticsOrderHourTable from './StaticsOrderHourTable'
import { staticsOrderByPeriod } from "../../../services/api/apiOrdersReport"
import downloadCsv from '../../../components/ExportCSV/downloadCsv'


const StaticsOrderHourPage = () => {

    const [loading, setLoading] = useState(false)
    const [dateFrom, setDateFrom] = useState(moment())
    const [dateTo, setDateTo] = useState(moment())
    const [data, setData] = useState([])
    const [error, setError] = useState('')

    const _fetchData = async () => {
        setLoading(true)
        setError('')
        setData([])

        try {
            const params = {
                date_from: moment(dateFrom).format('DD/MM/YYYY'),
                date_to: moment(dateTo).format('DD/MM/YYYY'),
            }
            const isSameDay = moment(dateFrom).isSame(moment(dateTo), 'day')
            const { data: response } = await staticsOrderByPeriod(params)
            const { success, data: responseData, message } = response

            if (!success) {
                setError(message)
                return
            }

            const { items } = responseData

            const newData = items.map((item, index) => {
                if (isSameDay) {
                    return {
                        ...item,
                        phase_time: index > 9
                            ? `${index}:00 - ${index}:59`
                            : `0${index}:00 - 0${index}:59`
                    }
                } else {
                    return {
                        ...item,
                        phase_time: moment(item.time, 'DD/MM/YYYY').format('MM/DD/YYYY')
                    }
                }
            })
            setData(newData)
        } catch (e) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        _fetchData()
    }, [dateFrom, dateTo])

    const _handleExport = () => {
        downloadCsv(data, {
            mapCols: {
                phase_time: 'Time',
                totalOrders: 'Total Orders',
                totalItems: 'Total Items',
                totalItemsBinhMinh: 'Item Binh Minh',
                totalItemsQuangMinh: 'Item Quang Minh',
                totalItemsQuangMinhFBA: 'Item Quang Minh FBA',
            },
            prefix: [`static-order-hour`].filter(Boolean).join('-') + '-',
        })
    }

    return (
        <Row className='text-center'>
            <Col md={12}>
                <div className="StaticsOrderHourPage StaticsCreatedPage">
                    <Card>
                        <CardHeader className="CardHeader text-white header-elements-inline">
                            <h2 className="card-title d-flex align-items-center">
                                <IconHead2 />
                                Thống kê đơn theo giờ
                            </h2>
                        </CardHeader>
                        <CardBody>
                            <div className="SearchDateTime d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <span>Từ ngày</span>
                                    <div className='DatePicker ml-2'>
                                        <DatePicker
                                            value={dateFrom}
                                            format="DD/MM/YYYY"
                                            onChange={setDateFrom}
                                            allowClear={false}
                                            className='mr-2'
                                        />
                                    </div>
                                    <span>Đến ngày</span>
                                    <div className='DatePicker ml-2'>
                                        <DatePicker
                                            value={dateTo}
                                            format="DD/MM/YYYY"
                                            onChange={setDateTo}
                                            allowClear={false}
                                            className='mr-2'
                                        />
                                        <i className={['BtnRefresh fa fa-refresh', loading && 'disabled spinner'].filter(Boolean).join(' ')}
                                           onClick={_fetchData} title={'Tải lại'}/>
                                    </div>
                                </div>
                                <div className="Export d-flex align-items-center">
                                    <button type="default" className='btn btn-primary' disabled={!data.length} onClick={_handleExport}>
                                        Export
                                    </button>
                                </div>
                            </div>
                            <div className="TableStatics d-flex justify-content-between">
                                <StaticsOrderHourTable data={!!data ? data : []} loading={loading} error={error} />
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Col>
        </Row>
    )
}

export default StaticsOrderHourPage
